// extracted by mini-css-extract-plugin
module.exports = {"cardHeadline":"roleAssignment_cardHeadline__1ZFEv","subscriptionSelector":"roleAssignment_subscriptionSelector__38J0c"};